/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AtlassianIcon } from '@atlaskit/logo';

interface Props {
	avatarUrl: string | null;
	alt?: string;
}

interface State {
	imageLoadFailed: boolean;
}

const styles = cssMap({
	image: {
		width: token('space.300'),
		height: token('space.300'),
		marginTop: token('space.050'),
		marginRight: token('space.050'),
		marginBottom: token('space.050'),
		marginLeft: token('space.050'),
		borderRadius: token('border.radius'),
	},
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
	},
});

export default class Avatar extends React.Component<Props, State> {
	state = {
		imageLoadFailed: false,
	};

	render() {
		const { avatarUrl, alt } = this.props;
		return (
			<div css={styles.container}>
				{(!avatarUrl || this.state.imageLoadFailed) && <AtlassianIcon size="medium" />}
				{avatarUrl && !this.state.imageLoadFailed && (
					<img alt={alt} css={styles.image} src={avatarUrl} onError={this.onError} />
				)}
			</div>
		);
	}

	private onError = () => {
		this.setState({ imageLoadFailed: true });
	};
}
